const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/$/, '');

const getToken = () => {
  try {
    const raw = localStorage.getItem('admin-auth-storage');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.state?.token || null;
  } catch {
    return null;
  }
};

export const adminFetch = async (path, options = {}) => {
  const token = getToken();
  const headers = {
    ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
    ...(options.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || 'Request failed');
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
};

export const getAdminStats = () => adminFetch('/admin/stats');
export const getAdminUsers = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return adminFetch(`/admin/users${qs ? `?${qs}` : ''}`);
};
export const updateAdminUser = (id, body) =>
  adminFetch(`/admin/users/${id}`, { method: 'PATCH', body: JSON.stringify(body) });

export const getAdminCandidates = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return adminFetch(`/admin/candidates${qs ? `?${qs}` : ''}`);
};
export const updateCandidateLevel = (slug, level) =>
  adminFetch(`/admin/candidates/${encodeURIComponent(slug)}/level`, {
    method: 'PATCH',
    body: JSON.stringify({ level }),
  });

export const getAdminPosts = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return adminFetch(`/admin/posts${qs ? `?${qs}` : ''}`);
};
export const updateAdminPost = (id, body) =>
  adminFetch(`/admin/posts/${id}`, { method: 'PATCH', body: JSON.stringify(body) });
export const deleteAdminPost = (id) =>
  adminFetch(`/admin/posts/${id}`, { method: 'DELETE' });

export const getAdminJobs = () => adminFetch('/admin/jobs');
export const createAdminJob = (body) =>
  adminFetch('/admin/jobs', { method: 'POST', body: JSON.stringify(body) });
export const updateAdminJob = (id, body) =>
  adminFetch(`/admin/jobs/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(body) });
export const deleteAdminJob = (id) =>
  adminFetch(`/admin/jobs/${encodeURIComponent(id)}`, { method: 'DELETE' });

export const uploadAdminJobLogo = async (file) => {
  const token = getToken();
  const formData = new FormData();
  formData.append('logo', file);
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/$/, '');
  const response = await fetch(`${API_BASE}/admin/jobs/logo`, {
    method: 'POST',
    headers,
    body: formData,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Logo upload failed');
  }
  return data;
};

export const uploadAdminJobJd = async (file) => {
  const token = getToken();
  const formData = new FormData();
  formData.append('jd', file);
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/$/, '');
  const response = await fetch(`${API_BASE}/admin/jobs/jd`, {
    method: 'POST',
    headers,
    body: formData,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'JD upload failed');
  }
  return data;
};

export const getAdminJobPostings = () => adminFetch('/admin/job-postings');
export const updateAdminJobPosting = (id, body) =>
  adminFetch(`/admin/job-postings/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
export const deleteAdminJobPosting = (id) =>
  adminFetch(`/admin/job-postings/${encodeURIComponent(id)}`, { method: 'DELETE' });

export const getAdminApplications = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return adminFetch(`/admin/applications${qs ? `?${qs}` : ''}`);
};

/** Authenticated resume URL for inline PDF viewing in a new tab */
export const getAdminApplicationResumeUrl = (applicationId, { download = false } = {}) => {
  const token = getToken();
  const params = new URLSearchParams();
  if (token) params.set('token', token);
  if (download) params.set('download', '1');
  const qs = params.toString();
  return `${API_BASE}/admin/applications/${encodeURIComponent(applicationId)}/resume${
    qs ? `?${qs}` : ''
  }`;
};

export const updateAdminApplication = (id, body) =>
  adminFetch(`/admin/applications/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
export const deleteAdminApplication = (id) =>
  adminFetch(`/admin/applications/${encodeURIComponent(id)}`, { method: 'DELETE' });

export const getAdminDbInfo = () => adminFetch('/admin/db/info');
export const getAdminDbCollections = () => adminFetch('/admin/db/collections');
export const getAdminDbDocuments = (name, params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return adminFetch(`/admin/db/collections/${encodeURIComponent(name)}${qs ? `?${qs}` : ''}`);
};
